/**
 * PestCategories — мини-справочник «Категории вредителей» (AK-233).
 * Тонкий wrapper над `ReferenceMiniCatalog`. DELETE-guard через usage_count.
 */
import { PlatformAdminLayout } from '@/layouts/PlatformAdminLayout';
import { ReferenceMiniCatalog } from '@/components/reference/ReferenceMiniCatalog';
import {
  useCreatePestCategory,
  useDeletePestCategory,
  usePestCategories,
  useUpdatePestCategory,
} from './hooks/useCatalogQueries';
import { toast } from '@/lib/toast';

function plural(n: number): string {
  const m10 = n % 10;
  const m100 = n % 100;
  if (m100 >= 11 && m100 <= 14) return 'вредителей';
  if (m10 === 1) return 'вредитель';
  if (m10 >= 2 && m10 <= 4) return 'вредителя';
  return 'вредителей';
}

export function PlatformAdminPestCategoriesPage() {
  const q = usePestCategories();
  const createMut = useCreatePestCategory();
  const updateMut = useUpdatePestCategory();
  const deleteMut = useDeletePestCategory();

  const items = q.data?.items ?? [];

  return (
    <PlatformAdminLayout>
      <ReferenceMiniCatalog
        title="Категории вредителей"
        subtitle={`Мини-справочник · ${items.length} записей`}
        createLabel="Добавить категорию"
        usageBadgeUnit={plural}
        guardMessage="Используется вредителями — нельзя удалить"
        items={items}
        isLoading={q.isLoading}
        onCreate={async (payload) => {
          await createMut.mutateAsync(payload);
          toast.success('Категория создана');
        }}
        onUpdate={async (id, payload) => {
          await updateMut.mutateAsync({ id, payload });
          toast.success('Категория обновлена');
        }}
        onDelete={async (id) => {
          // Отказ ловит и показывает сам ReferenceMiniCatalog (AK-574).
          await deleteMut.mutateAsync(id);
          toast.success('Категория удалена');
        }}
      />
      <p className="mt-3 text-[11px] text-muted-foreground">
        Изменения сразу доступны в select формы вредителя. EN-перевод отложен —
        ведём только RU.
      </p>
    </PlatformAdminLayout>
  );
}

export default PlatformAdminPestCategoriesPage;
